import React from 'react';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import './EMTPlaceholder.scss';

export const EMTPlaceholder = () => {
  return (
    <div className="emt-placeholder">
      { new Array(13).fill('').map((text, i) => {
        return (
          <Placeholder key={i} type="text" />
        );
      })}
    </div>
  );
};